import React, { DispatchWithoutAction, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { Disclosure, Transition as PopTransition } from '@headlessui/react'
import { SocialProfile } from 'layouts/footer'

export default function MobileNavModal({
  toggle,
}: {
  toggle: DispatchWithoutAction
}) {
  const navigate = useNavigate()
  const navigateTo = (target: string) => {
    navigate(target)
    toggle()
  }

  const modalRef = useRef<HTMLDivElement>(null)
  const organizationsBtn = useRef<HTMLButtonElement>(null)
  const sustainabilityBtn = useRef<HTMLButtonElement>(null)
  const techBtn = useRef<HTMLButtonElement>(null)
  const farmersBtn = useRef<HTMLButtonElement>(null)
  const companyBtn = useRef<HTMLButtonElement>(null)

  return (
    <section className="min-h-full bg-white text-dark overflow-auto flex flex-col flex-nowrap z-[999]">
      <div className=" flex-0 flex flex-nowrap gap-5 items-center justify-between pl-5 pr-3 border-b-1 border-slate-300 py-3">
        {/* <img src={logo} alt="Buyerr Logo" className="h-[3rem]" /> */}
        <svg
          version="1.2"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 783 183"
          className="h-[2.5rem] lg:h-12 2xl:h-16"
        >
          <title>BharatRohan's Logo</title>
          <defs>
            <linearGradient
              id="g1"
              x2="1"
              gradientUnits="userSpaceOnUse"
              gradientTransform="matrix(92.681,61.069,-14.963,22.708,4.25,124.52)"
            >
              <stop offset="0" stopColor="#8dbe3f" />
              <stop offset=".166" stopColor="#86b53d" />
              <stop offset=".428" stopColor="#749e38" />
              <stop offset=".752" stopColor="#567a30" />
              <stop offset="1" stopColor="#3c5929" />
            </linearGradient>
            <linearGradient
              id="g2"
              x2="1"
              gradientUnits="userSpaceOnUse"
              gradientTransform="matrix(92.681,61.069,-23.883,36.246,6.003,121.86)"
            >
              <stop offset="0" stopColor="#8dbe3f" />
              <stop offset=".166" stopColor="#86b53d" />
              <stop offset=".428" stopColor="#749e38" />
              <stop offset=".752" stopColor="#567a30" />
              <stop offset="1" stopColor="#3c5929" />
            </linearGradient>
            <linearGradient
              id="g3"
              x2="1"
              gradientUnits="userSpaceOnUse"
              gradientTransform="matrix(-92.681,0,0,-60.003,185.09,-424)"
            >
              <stop offset="0" stopColor="#8dbe3f" />
              <stop offset=".166" stopColor="#86b53d" />
              <stop offset=".428" stopColor="#749e38" />
              <stop offset=".752" stopColor="#567a30" />
              <stop offset="1" stopColor="#3c5929" />
            </linearGradient>
            <linearGradient
              id="g4"
              x2="1"
              gradientUnits="userSpaceOnUse"
              gradientTransform="matrix(-92.681,61.069,-23.883,-36.246,183.338,121.86)"
            >
              <stop offset="0" stopColor="#8dbe3f" />
              <stop offset=".166" stopColor="#86b53d" />
              <stop offset=".428" stopColor="#749e38" />
              <stop offset=".752" stopColor="#567a30" />
              <stop offset="1" stopColor="#3c5929" />
            </linearGradient>
          </defs>
          <path
            id="Layer"
            fillRule="evenodd"
            className="fill-none"
            d="m12.4 116q-0.1 0-0.2 0 0.1 0 0.2 0z"
          />
          <path
            id="Layer"
            className="fill-[#d69846]"
            d="m127.4 124.6c15.3-15.3 34.4-26.7 55.5-32.8q0 0.1 0 0.2c0-5.4-1-13.9-1-13.2-23.6 7.7-44.5 22.1-60.1 41q3 2.2 5.6 4.8 0 0 0 0z"
          />
          <path
            id="Layer"
            className="fill-[#daa543]"
            d="m115.5 115.9c15.2-23 37.4-40.6 63.4-50.2q-1-3.4-2.6-7.2-1.4-3.4-2.9-6.3c-28.1 11.9-51.4 33.4-65.3 60.7q3.8 1.2 7.4 3 0 0 0 0z"
          />
          <path
            id="Layer"
            className="fill-[#e1af3f]"
            d="m101.6 111.4q0 0 0 0c12.2-30.9 35.9-55.8 65.6-69.6q-4.2-6-9.3-11.2c-31 16.4-54.8 45.2-64.3 80.3q0.5 0 0.9 0 3.6 0 7.1 0.5z"
          />
          <path
            id="Layer"
            className="fill-yellow"
            d="m87.1 111.5q0 0 0.1 0c6.4-38.4 29.5-70.5 61.2-89.4-4.1-3.1-8.5-5.9-13-8.3-30.8 21.3-52.2 55.6-55.4 95.7q-0.2 1.9-0.3 3.8 3.6-1.2 7.4-1.8z"
          />
          <path
            id="Layer"
            className="fill-[#efc639]"
            d="m72.8 116.3q-0.5-9.1 0.2-18.5c0.6-7.7 2.5-21.8 8.9-37.7 10.7-26.7 28.4-43.7 38.8-52.3-2.7-1-5.9-1.7-9.7-2.4-3.5-0.7-7-1.2-9.8-1.3-8.5 8.5-20.6 22.9-28.9 43.7-3 7.4-7.3 20.4-8.7 37.2-1 12.4-0.2 24.4 2.1 36q3.3-2.7 7.1-4.7 0 0 0 0z"
          />
          <path
            id="Layer"
            className="fill-[#f3d433]"
            d="m60.1 126.2c-5.3-15.9-7.5-33.1-6.1-50.9 2.2-26.8 12.5-51.1 28.3-70.6-7.8 1.1-15.2 3.2-22.2 6.1-9.6 16.3-15.7 34.9-17.4 55-1.8 22.4 2.3 44 10.9 63.2q1.5 0.8 3 1.6 1.6-2.3 3.5-4.4z"
          />
          <path
            id="Layer"
            className="fill-[#f7df2f]"
            d="m43.8 124.5q0 0 0 0c-9.4-19.8-13.9-42.3-12-65.7 1-12.7 3.9-24.9 8.3-36.2-9.3 7.3-17 16.3-22.8 26.6q-0.1 1-0.2 2c-2 24.6 3.1 48.2 13.5 68.7q0 0 0 0 6.8 1.9 13.2 4.6z"
          />
          <path
            id="Layer"
            className="fill-[#d18a49]"
            d="m132.8 131.1c11.5-6.2 23.9-10.6 37.1-13.1q5-1.5 10.2-2.7 1.6-5.6 2.4-11.4c-18.8 4.7-36.1 13.6-50.8 25.7q0 0 0 0 0.6 0.7 1.1 1.5z"
          />
          <path
            id="Layer"
            className="fill-[#fbe625]"
            d="m119.3 133.5q0 0 0 0-2.2-2.2-4.7-4 0 0 0 0-2.5-1.8-5.3-3.2 0 0 0 0-3-1.4-6.2-2.2 0 0 0 0-2.7-0.7-5.5-1 0 0 0 0-1.5-0.1-3.1-0.1-1.8 0-3.5 0.2 0 0 0 0-2.8 0.3-5.3 1 0 0 0 0-3.1 0.8-6 2.2 0 0 0 0-2.8 1.3-5.3 3.2 0 0 0 0-2.9 2.1-5.3 4.7 0 0 0 0-1.1 1.2-2.1 2.6 2 1.4 4 2.8 0 0 0 0 3.6 2.6 7 5.5 0 0 0 0 2.6 2.2 5 4.4 0 0 0 0 2.1 2 4 4 0 0 0 0 1.4 1.4 2.7 2.8 0 0 0 0 1.5 1.6 2.9 3.3 0 0 0 0 1 1.1 1.9 2.2 0 0 0 0 0.1 0.1 0.1 0.2 1.3-1.5 2.6-3 0 0 0 0 2.1-2.3 4.2-4.5 3.8-3.9 8-7.4 0-0.1 0-0.1 6.2-5.3 13-9.8-1.4-2-3.1-3.8z"
          />
          <path
            id="Layer"
            className="fill-[#fbe625]"
            d="m12.2 116q0.1 0 0.2 0 0 0 0 0 1.4 0.2 2.7 0.5 2.8 0.4 5.6 1c-6.5-12.5-11.1-26.1-13.2-40.4-0.8 4.8-1.3 9.8-1.3 14.9 0 8.2 1.1 16.1 3.3 23.7q0 0 0 0 1.3 0.1 2.7 0.3z"
          />
          <path
            id="Layer"
            className="fill-[#ffffff]"
            d="m12.4 116q0 0 0 0 4.2 0.6 8.3 1.5 0 0 0 0-2.8-0.6-5.6-1-1.3-0.3-2.7-0.5z"
          />
          <path
            id="Layer"
            className="fill-[#ffffff]"
            d="m12.2 116q-1.4-0.2-2.7-0.3 0 0 0 0 0 0 0 0 1.3 0.1 2.7 0.3z"
          />
          <path
            id="Layer"
            className="fill-[url(#g1)]"
            d="m94.5 180.4l-0.1-0.3q0 0 0 0 0 0 0 0 0 0 0 0 0-0.1-0.1-0.1 0 0 0-0.1-0.1 0-0.1-0.1-0.1-0.1-0.2-0.2-0.2-0.3-0.3-0.5-0.1-0.1-0.2-0.2-0.2-0.3-0.4-0.6-0.5-0.6-0.9-1.2-0.4-0.5-0.9-1.1-0.5-0.6-1-1.3-0.3-0.4-0.7-0.9-0.6-0.7-1.2-1.4-0.2-0.3-0.5-0.6-0.7-0.9-1.5-1.7 0 0 0 0-3.8-4.4-7.9-8.3 0 0 0 0.1-5.4-5.2-11.4-9.7 0 0 0 0-2.7-2.1-5.6-4.1-1.3-0.8-2.6-1.7-1.3-0.8-2.5-1.6-0.1 0-0.2-0.1-0.3-0.1-0.6-0.3 0 0 0 0-2.3-1.4-4.7-2.7 0-0.1 0-0.1-4.9-2.6-10.1-4.9c-8.5-3.7-17.5-6.5-26.9-8.4 10.6 23.7 31.3 41.9 56.6 49.1q0.4 0.1 0.9 0.2 0.1 0 0.1 0.1c7.3 1.9 14.9 2.9 22.8 2.9q0.2 0 0.4 0z"
          />
          <path
            id="Layer"
            className="fill-[url(#g2)]"
            d="m94.4 180.1q0 0 0 0 0 0 0 0 0 0 0 0z"
          />
          <path
            id="Layer"
            className="fill-[url(#g3)]"
            d="m94.8 180.4l0.1-0.3h0.1q0 0 0 0 0 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0.1-0.1 0 0 0-0.1 0.1-0.1 0.2-0.2 0.2-0.3 0.4-0.5 0-0.1 0.1-0.2 0.2-0.3 0.5-0.6 0.4-0.6 0.9-1.2 0.4-0.5 0.8-1.1 0.5-0.6 1-1.3 0.4-0.4 0.8-0.9 0.5-0.7 1.1-1.4 0.3-0.3 0.5-0.6 0.8-0.9 1.5-1.7 0 0 0 0 3.8-4.4 7.9-8.3 0 0 0 0.1 5.4-5.2 11.4-9.7 0 0 0 0 2.8-2.1 5.7-4.1 1.2-0.8 2.6-1.7 1.2-0.8 2.5-1.6 0.1 0 0.2-0.1 0.2-0.1 0.5-0.3 0 0 0 0 2.4-1.4 4.8-2.7 0-0.1 0-0.1 4.9-2.6 10-4.9c8.6-3.7 17.6-6.5 26.9-8.4-10.5 23.7-31.2 41.9-56.6 49.1q-0.4 0.1-0.9 0.2 0 0-0.1 0.1c-7.2 1.9-14.8 2.9-22.7 2.9q-0.2 0-0.4 0z"
          />
          <path
            id="Layer"
            className="fill-[url(#g4)]"
            d="m94.9 180.1q0.1 0 0.1 0 0 0 0 0 0 0-0.1 0z"
          />
          <path
            id="Layer"
            fillRule="evenodd"
            className="fill-green"
            d="m342.5 82.2c4.9-1.5 12.2-2.4 18.8-2.4 15.1 0 22.2 5.8 22.2 14.9 0 1.9-0.3 4-0.9 6.3l-6.7 25h-18.9l1.2-4.6c-4.1 3.4-7.5 5.6-12.8 5.6-7 0-12.2-4.6-12.2-12.4 0-9.6 7.5-15.9 20.4-15.9 3.4 0 7 0.5 10.4 1.5l0.2-0.5c0.1-0.5 0.3-1.5 0.3-2.2 0-2.8-2.3-4.4-7-4.4-4.2 0-9.4 0.8-12.5 2q-1.2 0.4-2.4 0.9-0.9 0.4-1.9 1c-1.1 0.7-2 1.5-2.8 2.2m24.1 9.7l0.5-1.9c-1.3-0.3-2.3-0.5-3.5-0.5-4.8 0-7.5 2.2-7.5 6.2 0 2.3 1.4 3.6 3.1 3.6 3 0 6.3-3.1 7.4-7.4zm-68.7-43.8h18.9l-5.6 21c3-3.6 7.9-6.7 13.6-6.7 8.3 0 13 5.4 13 13.9 0 2.4-0.3 4.9-1.1 7.7l-6.7 25h-18.9l6.1-22.7c0.3-1.1 0.5-2.5 0.5-3.4 0-2.4-1.3-4-4-4-3.8 0-5.8 2.5-7.1 7.4l-6.1 22.7h-19zm100 15.4h18.9l-2.4 9.1c4.3-6.1 9.5-10.1 16.9-9.8l-5.3 20.1h-2.1c-8.9 0-13.7 4.7-16.3 14.8l-3 11.3h-18.9zm82.4 34.1c0-1.9 0.4-4 1-6.3l3.5-13.2h-5.4l4-14.6h5.3l3.1-11.4h19l-3.1 11.4h10.5l-3.9 14.6h-10.5l-2.6 9.8c-0.5 1.5-0.6 2.5-0.6 3.5 0 1.9 1.1 2.9 3.8 2.9 1.5 0 2.9-0.3 5.5-1l-4.1 15.4c-3.2 0.8-6.4 1.3-9.6 1.3-10.7 0-15.9-4-15.9-12.4zm94.5-8.7c0-13.9 11.5-26.5 27.4-26.5 14.3 0 22.8 9.4 22.8 21.2 0 13.9-11.5 26.5-27.4 26.5-14.3 0-22.8-9.3-22.8-21.2zm32.3-4.5c0-3.8-2.4-6.6-6.1-6.6-4.8 0-8.3 4.9-8.3 10.3 0 3.8 2.4 6.6 6.1 6.6 4.8 0 8.3-4.8 8.3-10.3zm31.4-36.2h19l-5.7 21c3-3.7 7.9-6.8 13.6-6.8 8.4 0 13.1 5.4 13.1 13.9 0 2.4-0.4 5-1.1 7.7l-6.7 25h-19l6.1-22.6c0.4-1.2 0.5-2.5 0.5-3.5 0-2.4-1.2-4-4-4-3.8 0-5.8 2.5-7.1 7.5l-6.1 22.6h-19zm100 15.4h19l-1.5 5.7c3-3.7 7.9-6.8 13.6-6.8 8.4 0 13.1 5.4 13.1 13.9 0 2.4-0.4 5-1.1 7.7l-6.7 25h-19l6.1-22.7c0.3-1.1 0.5-2.5 0.5-3.4 0-2.4-1.3-4-4-4-3.8 0-5.8 2.5-7.1 7.4l-6.1 22.7h-19zm-456.5 27.8c0 9.8-7.9 17.8-27.9 17.8h-31.9l15.7-58.4h25.9c18 0 22.4 6.6 22.4 13.7 0 7.1-4.8 13.1-13.7 15.4 5.5 1.4 9.5 5.5 9.5 11.5zm-14.9-22.4c0-2.4-1.8-3.4-6-3.4h-8.1l-2.2 8.1-3.3 12-2.3 8.7h9.4c4.8 0 7.7-2.1 7.7-5 0-2.5-2.1-3.7-6.3-3.7h-3.6l3.3-12h4.1c5 0 7.3-2.2 7.3-4.7zm292.1 20.7l8.1 19.5h-21.1l-6.5-16.7h-0.1l3.8-13.9h2.2c6.6 0 10-3 10-6.7 0-1.2-0.4-2.3-1.3-3.1-1-1.1-3-1.7-5.7-1.7h-7l-2.5 9.5-8.9 32.6h-19.4l15.7-58.4h22.8c10.8 0 17.7 2.3 21.6 6.2 3.3 3.3 4.6 7.6 4.6 12.2 0 9.1-4.8 17-16.3 20.5zm-124-24.3c4.9-1.5 12.2-2.4 18.8-2.4 15.1 0 22.2 5.7 22.2 14.8 0 1.9-0.3 4.1-0.9 6.4l-6.7 25h-19l1.3-4.6c-4.1 3.4-7.5 5.6-12.8 5.6-7 0-12.2-4.6-12.2-12.5 0-9.5 7.5-15.8 20.4-15.8 3.4 0 6.9 0.5 10.4 1.5l0.1-0.5c0.2-0.6 0.4-1.5 0.4-2.3 0-2.8-2.3-4.4-7-4.4-4.2 0-9.4 0.9-12.5 2l-2.4 0.9q-0.9 0.4-1.9 1c-1.1 0.7-2.1 1.5-2.8 2.3zm19.5 26.6l0.5-1.9c-1.3-0.3-2.3-0.5-3.5-0.5-4.8 0-7.5 2.3-7.5 6.2 0 2.3 1.4 3.6 3.1 3.6 3 0 6.3-3.1 7.4-7.4zm233.1-26.8c4.9-1.5 12.2-2.4 18.8-2.4 15.1 0 22.1 5.7 22.1 14.8 0 1.9-0.2 4.1-0.8 6.4l-6.7 25h-19l1.3-4.6c-4.1 3.4-7.5 5.6-12.8 5.6-7 0-12.2-4.6-12.2-12.4 0-9.6 7.5-15.9 20.4-15.9 3.4 0 6.9 0.5 10.4 1.5l0.1-0.5c0.2-0.6 0.4-1.5 0.4-2.2 0-2.9-2.3-4.5-7.1-4.5-4.1 0-9.3 0.9-12.4 2l-2.4 0.9q-0.9 0.4-1.9 1c-1.1 0.8-2.1 1.5-2.8 2.3zm19.5 26.6l0.5-1.9c-1.3-0.3-2.3-0.5-3.5-0.5-4.8 0-7.5 2.3-7.5 6.2 0 2.3 1.4 3.6 3.1 3.6 3 0 6.3-3.1 7.4-7.4z"
          />
        </svg>
        <button
          aria-label="Menu"
          type="button"
          onClick={toggle}
          className="rounded-full p-2 stroke-dark"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth="1.5"
            stroke="inherit"
            className="w-7 h-7"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      </div>
      <div className="bg-slate-50 flex flex-col gap-1 p-2 flex-1">
        <Disclosure>
          {({ open }) => (
            <>
              <Disclosure.Button
                ref={techBtn}
                className="text-lg font-semibold hover:bg-slate-200 w-full py-3 px-3 rounded-md flex  
              flex-nowrap items-center justify-between gap-2 text-dark"
              >
                <span>Technology</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth="1.5"
                  stroke="currentColor"
                  className={`${
                    open ? 'rotate-90 transform' : ''
                  } h-5 w-5 text-dark`}
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M8.25 4.5l7.5 7.5-7.5 7.5"
                  />
                </svg>
              </Disclosure.Button>
              <PopTransition
                show={open}
                enter="transition duration-100 ease-out"
                enterFrom="transform scale-95 opacity-0"
                enterTo="transform scale-100 opacity-100"
                leave="transition duration-75 ease-out"
                leaveFrom="transform scale-100 opacity-100"
                leaveTo="transform scale-95 opacity-0"
                className=""
              >
                {' '}
                <Disclosure.Panel
                  className="mx-1 mt-1 p-3  border-1 border-slate-300 rounded-md grid gap-2 text-base 
              leading-relaxed"
                >
                  <button
                    aria-label="Go to UAV's Page"
                    role="link"
                    type="button"
                    onClick={() => navigateTo('/technology?tech=uav')}
                    className="hover:underline underline-offset-2 text-left outline-offset-4 "
                  >
                    UAVs
                  </button>
                  <button
                    aria-label="Go to SaaS's Page"
                    role="link"
                    type="button"
                    onClick={() => navigateTo('/technology?tech=saas')}
                    className="hover:underline underline-offset-2 text-left outline-offset-4 "
                  >
                    SaaS
                  </button>
                </Disclosure.Panel>
              </PopTransition>
            </>
          )}
        </Disclosure>
        {/* BUSINESS */}
<Disclosure>
  {({ open }) => (
    <>
      <Disclosure.Button
        className="text-lg font-semibold hover:bg-slate-200 w-full py-3 px-3 rounded-md flex flex-nowrap items-center justify-between gap-2 text-dark"
      >
        <span>Business</span>

        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth="1.5"
          stroke="currentColor"
          className={`${
            open ? 'rotate-90 transform' : ''
          } h-5 w-5 text-dark`}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M8.25 4.5l7.5 7.5-7.5 7.5"
          />
        </svg>
      </Disclosure.Button>

      <PopTransition
        show={open}
        enter="transition duration-100 ease-out"
        enterFrom="transform scale-95 opacity-0"
        enterTo="transform scale-100 opacity-100"
        leave="transition duration-75 ease-out"
        leaveFrom="transform scale-100 opacity-100"
        leaveTo="transform scale-95 opacity-0"
      >
        <Disclosure.Panel className="mx-1 mt-1 p-3 border-1 border-slate-300 rounded-md grid gap-3 text-base leading-relaxed">

          {/* FOR FARMERS */}
          <Disclosure>
            {({ open }) => (
              <>
                <Disclosure.Button
                  className="font-semibold hover:bg-slate-200 w-full py-2 rounded-md flex flex-nowrap items-center justify-between gap-2 text-dark"
                >
                  <span>For Farmers</span>

                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="currentColor"
                    className={`${
                      open ? 'rotate-90 transform' : ''
                    } h-5 w-5 text-dark`}
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M8.25 4.5l7.5 7.5-7.5 7.5"
                    />
                  </svg>
                </Disclosure.Button>

                <PopTransition
                  show={open}
                  enter="transition duration-100 ease-out"
                  enterFrom="transform scale-95 opacity-0"
                  enterTo="transform scale-100 opacity-100"
                  leave="transition duration-75 ease-out"
                  leaveFrom="transform scale-100 opacity-100"
                  leaveTo="transform scale-95 opacity-0"
                >
                  <Disclosure.Panel className="ml-3 mt-2 border-l border-slate-300 pl-3 grid gap-2">

                    <button
                      type="button"
                      onClick={() => navigateTo('/crop-assure')}
                      className="hover:underline text-left"
                    >
                      CropAssure®
                    </button>

                    <button
                      type="button"
                      onClick={() =>
                        navigateTo('/crop-assure#crop-pricing')
                      }
                      className="hover:underline text-left"
                    >
                      Pricing
                    </button>

                  </Disclosure.Panel>
                </PopTransition>
              </>
            )}
          </Disclosure>

          {/* FOR ORGANISATIONS */}
          <Disclosure>
            {({ open }) => (
              <>
                <Disclosure.Button
                  className="font-semibold hover:bg-slate-200 w-full py-2 rounded-md flex flex-nowrap items-center justify-between gap-2 text-dark"
                >
                  <span>For Organisations</span>

                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="currentColor"
                    className={`${
                      open ? 'rotate-90 transform' : ''
                    } h-5 w-5 text-dark`}
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M8.25 4.5l7.5 7.5-7.5 7.5"
                    />
                  </svg>
                </Disclosure.Button>

                <PopTransition
                  show={open}
                  enter="transition duration-100 ease-out"
                  enterFrom="transform scale-95 opacity-0"
                  enterTo="transform scale-100 opacity-100"
                  leave="transition duration-75 ease-out"
                  leaveFrom="transform scale-100 opacity-100"
                  leaveTo="transform scale-95 opacity-0"
                >
                  <Disclosure.Panel className="ml-3 mt-2 border-l border-slate-300 pl-3 grid gap-2">

                    <button
                      type="button"
                      onClick={() => navigateTo('/source-assure')}
                      className="hover:underline text-left"
                    >
                      SourceAssure®
                    </button>

                    <button
                      type="button"
                      onClick={() => navigateTo('/seed-assure')}
                      className="hover:underline text-left"
                    >
                      SeedAssure®
                    </button>

                    <button
                      type="button"
                      onClick={() => {
                        window.location.href =
                          'https://safefoods.bharatrohan.in/products/'
                      }}
                      className="hover:underline text-left"
                    >
                      For Consumer
                    </button>

                  </Disclosure.Panel>
                </PopTransition>
              </>
            )}
          </Disclosure>
        </Disclosure.Panel>
      </PopTransition>
    </>
  )}
</Disclosure>        
        <Disclosure>
          {({ open }) => (
            <>
              <Disclosure.Button
                ref={organizationsBtn}
                className="text-lg font-semibold hover:bg-slate-200 w-full py-3 px-3 rounded-md flex  flex-nowrap items-center justify-between gap-2 text-dark"
              >
                <span>Investor Relations</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth="1.5"
                  stroke="currentColor"
                  className={`${
                    open ? 'rotate-90 transform' : ''
                  } h-5 w-5 text-dark`}
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M8.25 4.5l7.5 7.5-7.5 7.5"
                  />
                </svg>
              </Disclosure.Button>
              <PopTransition
                show={open}
                enter="transition duration-100 ease-out"
                enterFrom="transform scale-95 opacity-0"
                enterTo="transform scale-100 opacity-100"
                leave="transition duration-75 ease-out"
                leaveFrom="transform scale-100 opacity-100"
                leaveTo="transform scale-95 opacity-0"
                className=""
              >
                <Disclosure.Panel className="mx-1 mt-1 p-3  border-1 border-slate-300 rounded-md grid gap-2 text-base leading-relaxed">
                  <Disclosure>
                    {({ open }) => (
                      <>
                        <Disclosure.Button
                          ref={organizationsBtn}
                          className="font-semibold hover:bg-slate-200 w-full py-2 rounded-md flex  flex-nowrap items-center justify-between gap-2 text-dark"
                        >
                          <span>Management</span>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth="1.5"
                            stroke="currentColor"
                            className={`${
                              open ? 'rotate-90 transform' : ''
                            } h-5 w-5 text-dark`}
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              d="M8.25 4.5l7.5 7.5-7.5 7.5"
                            />
                          </svg>
                        </Disclosure.Button>
                        <PopTransition
                          show={open}
                          enter="transition duration-100 ease-out"
                          enterFrom="transform scale-95 opacity-0"
                          enterTo="transform scale-100 opacity-100"
                          leave="transition duration-75 ease-out"
                          leaveFrom="transform scale-100 opacity-100"
                          leaveTo="transform scale-95 opacity-0"
                          className=""
                        >
                          <Disclosure.Panel className="mx-1 mt-1 p-3  border-1 border-slate-300 rounded-md grid gap-2 text-base leading-relaxed">
                            <button
                              aria-label="Go to SourceAssure's Page"
                              role="link"
                              type="button"
                              onClick={() => navigateTo('/details-of-boards')}
                              className="hover:underline underline-offset-2 text-left outline-offset-4 "
                            >
                              Details Of Board
                            </button>
                          </Disclosure.Panel>
                          <Disclosure.Panel className="mx-1 mt-1 p-3  border-1 border-slate-300 rounded-md grid gap-2 text-base leading-relaxed">
                            <button
                              aria-label="Go to SourceAssure's Page"
                              role="link"
                              type="button"
                              onClick={() => navigateTo('/kmp')}
                              className="hover:underline underline-offset-2 text-left outline-offset-4 "
                            >
                              KMP & SMP
                            </button>
                          </Disclosure.Panel>
                          <Disclosure.Panel className="mx-1 mt-1 p-3  border-1 border-slate-300 rounded-md grid gap-2 text-base leading-relaxed">
                            <button
                              aria-label="Go to SourceAssure's Page"
                              role="link"
                              type="button"
                              onClick={() => navigateTo('/commitee')}
                              className="hover:underline underline-offset-2 text-left outline-offset-4 "
                            >
                              Committees
                            </button>
                          </Disclosure.Panel>
                        </PopTransition>
                      </>
                    )}
                  </Disclosure>
                  <Disclosure>
                    {({ open }) => (
                      <>
                        <Disclosure.Button
                          ref={organizationsBtn}
                          className="font-semibold hover:bg-slate-200 w-full py-2 rounded-md flex  flex-nowrap items-center justify-between gap-2 text-dark"
                        >
                          <span>Stock Exchange Filing</span>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth="1.5"
                            stroke="currentColor"
                            className={`${
                              open ? 'rotate-90 transform' : ''
                            } h-5 w-5 text-dark`}
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              d="M8.25 4.5l7.5 7.5-7.5 7.5"
                            />
                          </svg>
                        </Disclosure.Button>
                        <PopTransition
                          show={open}
                          enter="transition duration-100 ease-out"
                          enterFrom="transform scale-95 opacity-0"
                          enterTo="transform scale-100 opacity-100"
                          leave="transition duration-75 ease-out"
                          leaveFrom="transform scale-100 opacity-100"
                          leaveTo="transform scale-95 opacity-0"
                          className=""
                        >
                          <Disclosure.Panel className="mx-1 mt-1 p-3  border-1 border-slate-300 rounded-md grid gap-2 text-base leading-relaxed">
                            <button
                              aria-label="Go to Share Holding Pattern Page"
                              role="link"
                              type="button"
                              onClick={() => navigateTo('/shareholding-patterns')}
                              className="hover:underline underline-offset-2 text-left outline-offset-4 "
                            >
                              Share Holding Pattern
                            </button>
                          </Disclosure.Panel>
                          <Disclosure.Panel className="mx-1 mt-1 p-3  border-1 border-slate-300 rounded-md grid gap-2 text-base leading-relaxed">
                            <button
                              aria-label="Go to SDD Compliance Certificate Page"
                              role="link"
                              type="button"
                              onClick={() => navigateTo('/sdd-compliance')}
                              className="hover:underline underline-offset-2 text-left outline-offset-4 "
                            >
                              SDD Compliance Certificate
                            </button>
                          </Disclosure.Panel>
                          <Disclosure.Panel className="mx-1 mt-1 p-3  border-1 border-slate-300 rounded-md grid gap-2 text-base leading-relaxed">
                            <button
                              aria-label="Go to Certificate under Reg. 74 (5) of SEBI (DP) Regulations Page"
                              role="link"
                              type="button"
                              onClick={() => navigateTo('/certificate-under-sebi')}
                              className="hover:underline underline-offset-2 text-left outline-offset-4 "
                            >
                              Certificate under Reg. 74 (5) of SEBI (DP) Regulations
                            </button>
                          </Disclosure.Panel>
                          <Disclosure.Panel className="mx-1 mt-1 p-3  border-1 border-slate-300 rounded-md grid gap-2 text-base leading-relaxed">
                            <button
                              aria-label="Go to Corporate Governance Report Page"
                              role="link"
                              type="button"
                              onClick={() => navigateTo('/corporate-governance')}
                              className="hover:underline underline-offset-2 text-left outline-offset-4 "
                            >
                              Corporate Governance Report
                            </button>
                          </Disclosure.Panel>
                          <Disclosure.Panel className="mx-1 mt-1 p-3  border-1 border-slate-300 rounded-md grid gap-2 text-base leading-relaxed">
                            <button
                              aria-label="Go to Reconciliation of Share Capita Page"
                              role="link"
                              type="button"
                              onClick={() => navigateTo('/reconciliations')}
                              className="hover:underline underline-offset-2 text-left outline-offset-4 "
                            >
                              Reconciliation of Share Capital
                            </button>
                          </Disclosure.Panel>
                          <Disclosure.Panel className="mx-1 mt-1 p-3  border-1 border-slate-300 rounded-md grid gap-2 text-base leading-relaxed">
                            <button
                              aria-label="Go to Reconciliation of Share Capita Page"
                              role="link"
                              type="button"
                              onClick={() => navigateTo('/investors-meet')}
                              className="hover:underline underline-offset-2 text-left outline-offset-4 "
                            >
                              Investor Meet
                            </button>
                          </Disclosure.Panel>
                          <Disclosure.Panel className="mx-1 mt-1 p-3  border-1 border-slate-300 rounded-md grid gap-2 text-base leading-relaxed">
                            <button
                              aria-label="Go to Reconciliation of Share Capita Page"
                              role="link"
                              type="button"
                              onClick={() => navigateTo('/board-meeting')}
                              className="hover:underline underline-offset-2 text-left outline-offset-4 "
                            >
                              Board Meeting
                            </button>
                          </Disclosure.Panel>
                          <Disclosure.Panel className="mx-1 mt-1 p-3  border-1 border-slate-300 rounded-md grid gap-2 text-base leading-relaxed">
                            <button
                              aria-label="Go to Reconciliation of Share Capita Page"
                              role="link"
                              type="button"
                              onClick={() => navigateTo('/statement-deviation')}
                              className="hover:underline underline-offset-2 text-left outline-offset-4 "
                            >
                              Statement of Deviation
                            </button>
                          </Disclosure.Panel>
                          <Disclosure.Panel className="mx-1 mt-1 p-3  border-1 border-slate-300 rounded-md grid gap-2 text-base leading-relaxed">
                            <button
                              aria-label="Go to Reconciliation of Share Capita Page"
                              role="link"
                              type="button"
                              onClick={() => navigateTo('/press-release')}
                              className="hover:underline underline-offset-2 text-left outline-offset-4 "
                            >
                              Press Release
                            </button>
                          </Disclosure.Panel>
                          <Disclosure.Panel className="mx-1 mt-1 p-3  border-1 border-slate-300 rounded-md grid gap-2 text-base leading-relaxed">
                            <button
                              aria-label="Go to Reconciliation of Share Capita Page"
                              role="link"
                              type="button"
                              onClick={() => navigateTo('/others')}
                              className="hover:underline underline-offset-2 text-left outline-offset-4 "
                            >
                              Others
                            </button>
                          </Disclosure.Panel>
                        </PopTransition>
                      </>
                    )}
                  </Disclosure>
                  <Disclosure>
                    {({ open }) => (
                      <>
                        <Disclosure.Button
                          ref={organizationsBtn}
                          className="font-semibold hover:bg-slate-200 w-full py-2 rounded-md flex  flex-nowrap items-center justify-between gap-2 text-dark"
                        >
                          <span>Investor Services</span>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth="1.5"
                            stroke="currentColor"
                            className={`${
                              open ? 'rotate-90 transform' : ''
                            } h-5 w-5 text-dark`}
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              d="M8.25 4.5l7.5 7.5-7.5 7.5"
                            />
                          </svg>
                        </Disclosure.Button>
                        <PopTransition
                          show={open}
                          enter="transition duration-100 ease-out"
                          enterFrom="transform scale-95 opacity-0"
                          enterTo="transform scale-100 opacity-100"
                          leave="transition duration-75 ease-out"
                          leaveFrom="transform scale-100 opacity-100"
                          leaveTo="transform scale-95 opacity-0"
                          className=""
                        >
                          <Disclosure.Panel className="mx-1 mt-1 p-3  border-1 border-slate-300 rounded-md grid gap-2 text-base leading-relaxed">
                            <button
                              aria-label="Go to Share Holding Pattern Page"
                              role="link"
                              type="button"
                              onClick={() => navigateTo('/investor-grievance')}
                              className="hover:underline underline-offset-2 text-left outline-offset-4 "
                            >
                              Investor Grievances
                            </button>
                          </Disclosure.Panel>
                          <Disclosure.Panel className="mx-1 mt-1 p-3  border-1 border-slate-300 rounded-md grid gap-2 text-base leading-relaxed">
                            <button
                              aria-label="Go to SDD Compliance Certificate Page"
                              role="link"
                              type="button"
                              onClick={() => navigateTo('/investor-forms')}
                              className="hover:underline underline-offset-2 text-left outline-offset-4 "
                            >
                              Investor Forms
                            </button>
                          </Disclosure.Panel>
                        </PopTransition>
                      </>
                    )}
                  </Disclosure>                      
                  {/* <button
                    aria-label="Go to Investors Grievances Page"
                    role="link"
                    type="button"
                    onClick={() => navigateTo('/investor-grievance')}
                    className="hover:underline underline-offset-2 text-left outline-offset-4 "
                  >
                    Investors Grievances
                  </button> */}
                  <button
                    aria-label="Go to Investors Grievances Page"
                    role="link"
                    type="button"
                    onClick={() => navigateTo('/meetings')}
                    className="hover:underline underline-offset-2 text-left outline-offset-4 "
                  >
                    Meetings
                  </button>
                  {/* <button
                    aria-label="Go to Investors Grievances Page"
                    role="link"
                    type="button"
                    onClick={() => navigateTo('/policies')}
                    className="hover:underline underline-offset-2 text-left outline-offset-4 "
                  >
                    Policies
                  </button> */}
                  {/* <button
                    aria-label="Go to Share Holding Pattern Page"
                    role="link"
                    type="button"
                    onClick={() => navigateTo('/shareholding-patterns')}
                    className="hover:underline underline-offset-2 text-left outline-offset-4 "
                  >
                    Share Holding Pattern
                  </button> */}
                  <button
                    aria-label="Go to CSR Initiatives Page"
                    role="link"
                    type="button"
                    onClick={() => navigateTo('/csr')}
                    className="hover:underline underline-offset-2 text-left outline-offset-4 "
                  >
                    CSR Initiatives
                  </button>
                  <button
                    aria-label="Go to Financial Results Page"
                    role="link"
                    type="button"
                    onClick={() => navigateTo('/finance')}
                    className="hover:underline underline-offset-2 text-left outline-offset-4 "
                  >
                    Financial Results
                  </button>
                  <button
                    aria-label="Go to Group Company Page"
                    role="link"
                    type="button"
                    onClick={() => navigateTo('/group-companies')}
                    className="hover:underline underline-offset-2 text-left outline-offset-4 "
                  >
                    Group Company
                  </button>
                  <button
                    aria-label="Go to Subsidiary Company Page"
                    role="link"
                    type="button"
                    onClick={() => navigateTo('/subsidiary')}
                    className="hover:underline underline-offset-2 text-left outline-offset-4 "
                  >
                    Subsidiary Company
                  </button>
                  <button
                    aria-label="Go to IPO Page"
                    role="link"
                    type="button"
                    onClick={() => navigateTo('/ipo')}
                    className="hover:underline underline-offset-2 text-left outline-offset-4 "
                  >
                    IPO
                  </button>
                  <Disclosure>
                    {({ open }) => (
                      <>
                        <Disclosure.Button
                          ref={organizationsBtn}
                          className="font-semibold hover:bg-slate-200 w-full py-2 rounded-md flex  flex-nowrap items-center justify-between gap-2 text-dark"
                        >
                          <span>Others</span>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth="1.5"
                            stroke="currentColor"
                            className={`${
                              open ? 'rotate-90 transform' : ''
                            } h-5 w-5 text-dark`}
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              d="M8.25 4.5l7.5 7.5-7.5 7.5"
                            />
                          </svg>
                        </Disclosure.Button>
                        <PopTransition
                          show={open}
                          enter="transition duration-100 ease-out"
                          enterFrom="transform scale-95 opacity-0"
                          enterTo="transform scale-100 opacity-100"
                          leave="transition duration-75 ease-out"
                          leaveFrom="transform scale-100 opacity-100"
                          leaveTo="transform scale-95 opacity-0"
                          className=""
                        >
                          <Disclosure.Panel className="mx-1 mt-1 p-3  border-1 border-slate-300 rounded-md grid gap-2 text-base leading-relaxed">
                            <button
                              aria-label="Go to SourceAssure's Page"
                              role="link"
                              type="button"
                              onClick={() => navigateTo('/material-contracts')}
                              className="hover:underline underline-offset-2 text-left outline-offset-4 "
                            >
                              Material Contract
                            </button>
                          </Disclosure.Panel>
                          <Disclosure.Panel className="mx-1 mt-1 p-3  border-1 border-slate-300 rounded-md grid gap-2 text-base leading-relaxed">
                            <button
                              aria-label="Go to SourceAssure's Page"
                              role="link"
                              type="button"
                              onClick={() => navigateTo('/material-documents')}
                              className="hover:underline underline-offset-2 text-left outline-offset-4 "
                            >
                              Material Document
                            </button>
                          </Disclosure.Panel>
                          <Disclosure.Panel className="mx-1 mt-1 p-3  border-1 border-slate-300 rounded-md grid gap-2 text-base leading-relaxed">
                            <button
                              aria-label="Go to SourceAssure's Page"
                              role="link"
                              type="button"
                              onClick={() => navigateTo('/material-creditors')}
                              className="hover:underline underline-offset-2 text-left outline-offset-4 "
                            >
                              Material Creditors
                            </button>
                          </Disclosure.Panel>
                        </PopTransition>
                      </>
                    )}
                  </Disclosure>
                  <button
                    aria-label="Go to Investors Grievances Page"
                    role="link"
                    type="button"
                    onClick={() => navigateTo('/policies')}
                    className="hover:underline underline-offset-2 text-left outline-offset-4 "
                  >
                    Policies
                  </button>
                  <button
                    aria-label="Go to Investors Grievances Page"
                    role="link"
                    type="button"
                    onClick={() => navigateTo('/investor-deck')}
                    className="hover:underline underline-offset-2 text-left outline-offset-4 "
                  >
                    Investor Deck
                  </button>
                </Disclosure.Panel>
              </PopTransition>
            </>
          )}
        </Disclosure>
        {/* COMMUNITY */}
<Disclosure>
  {({ open }) => (
    <>
      <Disclosure.Button
        className="text-lg font-semibold hover:bg-slate-200 w-full py-3 px-3 rounded-md flex flex-nowrap items-center justify-between gap-2 text-dark"
      >
        <span>Community</span>

        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth="1.5"
          stroke="currentColor"
          className={`${
            open ? 'rotate-90 transform' : ''
          } h-5 w-5 text-dark`}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M8.25 4.5l7.5 7.5-7.5 7.5"
          />
        </svg>
      </Disclosure.Button>

      <PopTransition
        show={open}
        enter="transition duration-100 ease-out"
        enterFrom="transform scale-95 opacity-0"
        enterTo="transform scale-100 opacity-100"
        leave="transition duration-75 ease-out"
        leaveFrom="transform scale-100 opacity-100"
        leaveTo="transform scale-95 opacity-0"
      >
        <Disclosure.Panel className="mx-1 mt-1 p-3 border-1 border-slate-300 rounded-md grid gap-2 text-base leading-relaxed">

          <button
            type="button"
            onClick={() => navigateTo('/csr')}
            className="hover:underline text-left"
          >
            CSR
          </button>

          {/* Sustainability */}
          <Disclosure>
            {({ open }) => (
              <>
                <Disclosure.Button
                  className="font-semibold hover:bg-slate-200 w-full py-2 rounded-md flex flex-nowrap items-center justify-between gap-2 text-dark"
                >
                  <span>Sustainability</span>

                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="currentColor"
                    className={`${
                      open ? 'rotate-90 transform' : ''
                    } h-5 w-5 text-dark`}
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M8.25 4.5l7.5 7.5-7.5 7.5"
                    />
                  </svg>
                </Disclosure.Button>

                <PopTransition
                  show={open}
                  enter="transition duration-100 ease-out"
                  enterFrom="transform scale-95 opacity-0"
                  enterTo="transform scale-100 opacity-100"
                  leave="transition duration-75 ease-out"
                  leaveFrom="transform scale-100 opacity-100"
                  leaveTo="transform scale-95 opacity-0"
                >
                  <Disclosure.Panel className="ml-3 mt-2 border-l border-slate-300 pl-3 grid gap-2">

                    <button
                      type="button"
                      onClick={() => navigateTo('/sustainability')}
                      className="hover:underline text-left"
                    >
                      How we see sustainability?
                    </button>

                    <button
                      type="button"
                      onClick={() => navigateTo('/supply-chain')}
                      className="hover:underline text-left"
                    >
                      Supply chain traceability
                    </button>

                    <button
                      type="button"
                      onClick={() => navigateTo('/carbon-farming')}
                      className="hover:underline text-left"
                    >
                      Carbon farming
                    </button>

                    <button
                      type="button"
                      onClick={() => navigateTo('/ipm')}
                      className="hover:underline text-left"
                    >
                      IPM implementations
                    </button>

                  </Disclosure.Panel>
                </PopTransition>
              </>
            )}
          </Disclosure>

          <button
            type="button"
            onClick={() => navigateTo('/blogs')}
            className="hover:underline text-left"
          >
            Blogs
          </button>

          <button
            type="button"
            onClick={() => navigateTo('/esg-profile')}
            className="hover:underline text-left"
          >
            ESG Profile
          </button>

          <button
            type="button"
            onClick={() => navigateTo('/updates')}
            className="hover:underline text-left"
          >
            Updates
          </button>

          <button
            type="button"
            onClick={() => navigateTo('/careers')}
            className="hover:underline text-left"
          >
            Careers
          </button>

        </Disclosure.Panel>
      </PopTransition>
    </>
  )}
</Disclosure>
        <Disclosure>
          {({ open }) => (
            <>
              <Disclosure.Button
                ref={companyBtn}
                className="text-lg font-semibold hover:bg-slate-200 w-full py-3 px-3 rounded-md flex  flex-nowrap items-center justify-between gap-2 text-dark"
              >
                <div onClick={() => { 
                    window.location.href = "https://safefoods.bharatrohan.in/products/"; 
                  }}>
                    Shop Now
                </div>
              </Disclosure.Button>
            </>
          )}
        </Disclosure>
        {/* <Disclosure>
          {({ open }) => (
            <>
              <Disclosure.Button
                ref={companyBtn}
                className="text-lg font-semibold hover:bg-slate-200 w-full py-3 px-3 rounded-md flex  flex-nowrap items-center justify-between gap-2 text-dark"
              >
                <span>About us</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth="1.5"
                  stroke="currentColor"
                  className={`${
                    open ? 'rotate-90 transform' : ''
                  } h-5 w-5 text-dark`}
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M8.25 4.5l7.5 7.5-7.5 7.5"
                  />
                </svg>
              </Disclosure.Button>
              <PopTransition
                show={open}
                enter="transition duration-100 ease-out"
                enterFrom="transform scale-95 opacity-0"
                enterTo="transform scale-100 opacity-100"
                leave="transition duration-75 ease-out"
                leaveFrom="transform scale-100 opacity-100"
                leaveTo="transform scale-95 opacity-0"
                className=""
              >
                <Disclosure.Panel className="mx-1 mt-1 p-3  border-1 border-slate-300 rounded-md grid gap-2 text-base leading-relaxed">
                  <button
                    aria-label="Go to Our Company's Page"
                    role="link"
                    type="button"
                    onClick={() => navigateTo('/about-us')}
                    className="hover:underline underline-offset-2 text-left outline-offset-4 "
                  >
                    Our company
                  </button>
                  
                  
                  <Disclosure>
                    {({ open }) => (
                      <>
                        <Disclosure.Button
                          ref={organizationsBtn}
                          className="font-semibold hover:bg-slate-200 w-full py-2 rounded-md flex  flex-nowrap items-center justify-between gap-2 text-dark"
                        >
                          <span>Resources</span>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth="1.5"
                            stroke="currentColor"
                            className={`${
                              open ? 'rotate-90 transform' : ''
                            } h-5 w-5 text-dark`}
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              d="M8.25 4.5l7.5 7.5-7.5 7.5"
                            />
                          </svg>
                        </Disclosure.Button>
                        <PopTransition
                          show={open}
                          enter="transition duration-100 ease-out"
                          enterFrom="transform scale-95 opacity-0"
                          enterTo="transform scale-100 opacity-100"
                          leave="transition duration-75 ease-out"
                          leaveFrom="transform scale-100 opacity-100"
                          leaveTo="transform scale-95 opacity-0"
                          className=""
                        >
                          <Disclosure.Panel className="mx-1 mt-1 p-3  border-1 border-slate-300 rounded-md grid gap-2 text-base leading-relaxed">
                            <button
                              aria-label="Case Studies"
                              role="link"
                              type="button"
                              onClick={() => navigateTo('/case-studies')}
                              className="hover:underline underline-offset-2 text-left outline-offset-4 "
                            >
                              Case studies
                            </button>
                            <button
                              aria-label="Go to Blogs and Updates Page"
                              role="link"
                              type="button"
                              onClick={() => navigateTo('/blogs-and-updates')}
                              className="hover:underline underline-offset-2 text-left outline-offset-4 "
                            >
                              Blogs and updates
                            </button>
                          </Disclosure.Panel>
                        </PopTransition>
                      </>
                    )}
                  </Disclosure>

                  <button
                    aria-label="Go to Contact Us Page"
                    role="link"
                    type="button"
                    onClick={() => navigateTo('/contact-us')}
                    className="hover:underline underline-offset-2 text-left outline-offset-4 "
                  >
                    Contact us
                  </button>
                  <button
                    role="link"
                    type="button"
                    onClick={() => navigateTo('/careers')}
                    className="hover:underline underline-offset-2 text-left outline-offset-4 "
                  >
                    Careers
                  </button>
                </Disclosure.Panel>
              </PopTransition>
            </>
          )}
        </Disclosure> */}
        
      </div>

      <div className="flex items-center justify-center">
        <div className="max-w-xs flex items-center justify-center py-3 gap-x-6">
          <SocialProfile
            aria="LinkedIn"
            href={process.env.REACT_APP_LINKEDIN ?? 'https://bharatrohan.com'}
          >
            <svg
              width={26}
              height={26}
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 448 512"
            >
              <path
                fill="#193C34"
                d="M416 32H31.9C14.3 32 0 46.5 0 64.3v383.4C0 465.5 14.3 480 31.9 480H416c17.6 0 32-14.5 32-32.3V64.3c0-17.8-14.4-32.3-32-32.3zM135.4 416H69V202.2h66.5V416zm-33.2-243c-21.3 0-38.5-17.3-38.5-38.5S80.9 96 102.2 96c21.2 0 38.5 17.3 38.5 38.5 0 21.3-17.2 38.5-38.5 38.5zm282.1 243h-66.4V312c0-24.8-.5-56.7-34.5-56.7-34.6 0-39.9 27-39.9 54.9V416h-66.4V202.2h63.7v29.2h.9c8.9-16.8 30.6-34.5 62.9-34.5 67.2 0 79.7 44.3 79.7 101.9V416z"
              />
            </svg>
          </SocialProfile>
          <SocialProfile
            aria="Instagram"
            href={process.env.REACT_APP_INSTA ?? 'https://bharatrohan.com'}
          >
            <svg
              width={26}
              height={26}
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 448 512"
            >
              <path
                fill="#193C34"
                d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"
              />
            </svg>
          </SocialProfile>
          <SocialProfile
            aria="Facebook"
            href={process.env.REACT_APP_FB ?? 'https://bharatrohan.com'}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 512 512"
              width={26}
              height={26}
            >
              <path
                fill="#193C34"
                d="M504 256C504 119 393 8 256 8S8 119 8 256c0 123.78 90.69 226.38 209.25 245V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.28c-30.8 0-40.41 19.12-40.41 38.73V256h68.78l-11 71.69h-57.78V501C413.31 482.38 504 379.78 504 256z"
              />
            </svg>
          </SocialProfile>
        </div>
      </div>
    </section>
  )
}
